// extracted by mini-css-extract-plugin
export var button = "styles-module--button--11a60";
export var content = "styles-module--content--a3442";
export var contentWrapper = "styles-module--contentWrapper--c970f";
export var icon = "styles-module--icon--446db";
export var info = "styles-module--info--fbcb0";
export var wrapper = "styles-module--wrapper--a1a52";